export default "__VITE_ASSET__76a0dcb4__"